<link href="https://cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet" />
<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{titulo}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div
    *ngIf="!justText"
    class="trix-content"
    id="trix"
    [innerHTML]="text | safeHtml: 'html'"
  ></div>

  <quill-editor
    *ngIf="!justText"
    class="selectable"
    [disabled]="readOnly"
    placeholder="{{'Digite aqui' | translate}}..."
    [style]="{ height: '40%' }"
    [(ngModel)]="text"
  >
  </quill-editor>

  <ion-row *ngIf="readOnly || !justText">
    <ion-col size="12">
      <ion-button class="btn-default" expand="block" (click)="salvarHtml()">
        {{'Salvar' | translate}}
      </ion-button>
    </ion-col>
  </ion-row>
</ion-content>
